export abstract class AdminRoutesConstants {
  static readonly MAIN = "admin";
  static readonly AI_MODELS = "ai-models"; // Renaming LLMS to AI_MODELS in usage, but keeping LLMS route constant for backward compat if needed, but cleaner to use new one
  static readonly ORGANIZATIONS = "organizations";
  static readonly USERS = "users";
  static readonly PLANS = "plans";
  static readonly AI_USAGE = "ai-usage";

  static readonly main = (): string => `/${AdminRoutesConstants.MAIN}`;
  static readonly aiModels = (): string => `${this.main()}/${this.AI_MODELS}`;
  static readonly organizations = (): string => `${this.main()}/${this.ORGANIZATIONS}`;
  static readonly users = (): string => `${this.main()}/${this.USERS}`;
  static readonly plans = (): string => `${this.main()}/${this.PLANS}`;
  static readonly aiUsage = (): string => `${this.main()}/${this.AI_USAGE}`;
}
